import React from 'react'
import { APIENDPOINT, getCWPEnvironmentForURL } from '../shared/utils/common-utils'
import { Header } from '@ampdx/component-library/dist/components/'
import './CIHeader.scss'

export type CIHeaderProps = {
  content: {
    submitEmail: string
    submitSubject: string
    submitTipButton: string
    viewAllButton: string
  }
}

const CIHeader = (props: CIHeaderProps) => {
  const { submitEmail, submitSubject, submitTipButton, viewAllButton } = props?.content || {}
  const env = getCWPEnvironmentForURL(window.location.href)
  const path = window.location.pathname
  let normalizedPath = path
  while (normalizedPath.endsWith('/')) {
    normalizedPath = normalizedPath.slice(0, -1)
  }
  const isFirmPage = !normalizedPath.endsWith('/competitive-intelligence')

  return isFirmPage ? (
    <Header
      headerDocument={{
        utilityNavigation: [
          {
            text: viewAllButton,
            linkType: 'tertiary-button-blue',
            analytics: '',
            linkHref: `${APIENDPOINT(env).base}competitive-intelligence`,
          },
          {
            text: submitTipButton,
            linkType: 'primary-button-blue',
            analytics: '',
            linkHref: `mailto:${submitEmail}?subject=${submitSubject}`,
          },
        ],
      }}
      backgroundColor={'u-bgColorWhite'}
      textColor={'u-textColorActionBlue'}
      menuIconColor={'u-bgColorActionBlue'}
      layoutClass={'u-sizeConstrained'}
    />
  ) : (
    <Header
      headerDocument={{
        utilityNavigation: [
          {
            text: submitTipButton,
            linkType: 'primary-button-blue',
            analytics: '',
            linkHref: `mailto:${submitEmail}?subject=${submitSubject}`,
          },
        ],
      }}
      backgroundColor={'u-bgColorWhite'}
      textColor={'u-textColorActionBlue'}
      menuIconColor={'u-bgColorActionBlue'}
      layoutClass={'u-sizeConstrained'}
    />
  )
}

export default CIHeader
